<script setup>
import AnalysisColumnViewer from '@src/components/AnalysisColumnViewer.vue';
import ImageClipboard from '@src/components/ImageClipboard.vue';
import ImageExtractorDemo from '@src/components/ImageExtractorDemo.vue';

import { useGeneralPurposeOverlayManager } from '@src/store/overlay-management/overlay-manager';

const overlayManager = useGeneralPurposeOverlayManager();
const overlayState = overlayManager.getGeneralPurposeOverlayState();
</script>

<template>
  <transition name="slide-right-fade">
    <div
      v-if="overlayState.isOpen"
      class="series-container"
      :class="
        overlayState.positionType === 'inline' ? 'series-container-inline' : ''
      "
    >
      <AnalysisColumnViewer
        v-if="overlayState.viewerType === 'viewer'"
        class="full-height-viewer"
      />
      <ImageClipboard
        v-else-if="overlayState.viewerType === 'clipboard'"
        class="full-height-viewer"
      />
      <ImageExtractorDemo
        v-else-if="overlayState.viewerType === 'extractor'"
        class="full-height-viewer"
      />
    </div>
  </transition>
</template>

<style scoped>
.series-container {
  right: 5px;
  top: 60px;
  bottom: 5px;
  position: fixed;
  z-index: 9999999;
  display: flex;
  flex-direction: column;
  height: auto;
}

.series-container-inline {
  position: relative;
  right: auto;
  top: auto;
  bottom: auto;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.full-height-viewer {
  width: 100%;
  height: 100%;
  min-height: 0;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
}

/* Slide animation */
.slide-fade-enter-active {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.slide-fade-enter-from {
  transform: translateX(-20px) scale(0.9);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateX(-10px) scale(0.95);
  opacity: 1;
}

/* Slide in from right animation for GeneralPurposeContainer */
.slide-right-fade-enter-active,
.slide-right-fade-leave-active {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.slide-right-fade-enter-from {
  transform: translateX(40px);
  opacity: 0;
}
.slide-right-fade-leave-to {
  transform: translateX(40px);
  opacity: 0;
}
</style>
